/*
 * File: ResetPasswordConfirm.tsx
 * Project: a-a
 * File Created: Thursday, 24th October 2024 1:06:26 am
 * Author: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Last Modified: Wednesday, 23rd July 2025 10:15:30 pm
 * Modified By: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Copyright 2020 - 2024 Mutual Mobile, Mutual Mobile
 */
import React from 'react';
import styles from './ResetPasswordConfirm.module.css';
import EntryLayoutScreen from '../../shared/EntryLayout/EntryLayout';
import zeplinColor from '../../../theme/Color';
import CustomButton from '../../shared/CustomButton/CustomButton';
import { useNavigate } from 'react-router-dom';
import RoutePaths from '../../../routes/RoutePaths';

const ResetPasswordConfirm = () => {
  const navigate = useNavigate();
  const children = (
    <div className={styles['confirm-field']}>
      <CustomButton
        onClick={() => {
          navigate(RoutePaths.Root);
          sessionStorage.removeItem('next');
          sessionStorage.removeItem('user');
        }}
        variant='contained'
        disabled={false}
        color={'primary'}
        style={{ width: '172px', borderRadius: '14px', height: 56 }}
        textStyle={{ color: zeplinColor.Neutral1 }}
        text={'Back to Log In'}
      />
    </div>
  );
  return (
    <EntryLayoutScreen
      header={'Password reset!'}
      subheader={`Your password has been successfully reset. You can now 
log in again.`}
      input={children}
      alternative={''}
      footerText=''
      footerButtonText=''
      icon={
        <div
          style={{
            backgroundColor: zeplinColor.Neutral3,
            borderRadius: '70px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            margin: 'auto',
            width: '80px',
            height: '80px',
            padding: '20px',
          }}
        >
          <img src={'/assets/confirm.svg'} width={40} height={40} />
        </div>
      }
      clickAction={() => {}}
    />
  );
};

export default ResetPasswordConfirm;
